import { Plus } from "lucide-react";
import { VARIANT_LABELS } from "./constants";

export function CategoriesTab({
  categories, newCatName, setNewCatName, renameValues, setRenameValues, onAdd, onRename,
}) {
  return (
    <div data-testid="admin-categories-panel" className="grid grid-cols-1 gap-8 md:grid-cols-3">
      {Object.entries(VARIANT_LABELS).map(([key, label]) => (
        <div key={key} className="border border-white/10 bg-black/40 p-6">
          <p className="mb-5 font-heading text-sm font-bold uppercase tracking-[0.15em]">{label}</p>
          <div className="mb-5 max-h-[420px] space-y-2 overflow-y-auto pr-1">
            {(categories[key] || []).map((cat) => (
              <div key={cat.id} className="flex gap-2">
                <input
                  data-testid={`category-rename-input-${cat.id}`}
                  defaultValue={cat.name}
                  onChange={(e) => setRenameValues({ ...renameValues, [cat.id]: e.target.value })}
                  className="w-full border border-white/10 bg-black px-3 py-2 text-xs text-white outline-none focus:border-[#FFD700]/60"
                />
                <button
                  data-testid={`category-rename-save-${cat.id}`}
                  onClick={() => onRename(cat.id)}
                  className="shrink-0 rounded-full border border-white/15 px-3 text-[10px] font-bold uppercase text-[#A1A1A6] transition-colors duration-300 hover:border-[#FFD700]/60 hover:text-[#FFD700]"
                >
                  Save
                </button>
              </div>
            ))}
          </div>
          <div className="flex gap-2 border-t border-white/10 pt-4">
            <input
              data-testid={`category-add-input-${key}`}
              value={newCatName[key] || ""}
              onChange={(e) => setNewCatName({ ...newCatName, [key]: e.target.value })}
              placeholder="New category"
              className="w-full border border-white/10 bg-black px-3 py-2 text-xs text-white outline-none focus:border-[#FFD700]/60"
            />
            <button
              data-testid={`category-add-btn-${key}`}
              onClick={() => onAdd(key)}
              className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#FFD700] text-black"
            >
              <Plus className="h-4 w-4" />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
